/** @format */

import { useMap } from '@/@ducks/map/hooks/useMap';
import { TRoom } from '@/@ducks/room/declarations';
import Map from '@/components/ui/Map';
import React, { FC, useRef, useState } from 'react';
import { MapRef, NavigationControlProps } from 'react-map-gl';

interface MapRoomLocationProps extends NavigationControlProps {
  room: TRoom;
  onViewStateChange?: Function;
  scrollZoom?: boolean;
  disableMovement?: boolean;
}

export const MapRoomLocation: FC<MapRoomLocationProps> = ({ room, onViewStateChange, ...rest }) => {
  const { position } = room!;
  const mapRef = useRef<MapRef>(null);
  const [isMapInitiallyLoaded, setIsMapInitiallyLoaded] = useState(false);

  const coordinates = {
    latitude: position.latitude,
    longitude: position.longitude,
  };

  const { viewport, setViewport, pins } = useMap({
    coordinates,
    showMap: true,
    singleMarker: true,
    zoom: 14,
    mapRef,
    isMapLoading: false,
    isMapInitiallyLoaded,
  });

  return (
    <Map
      mapRef={mapRef}
      viewport={viewport}
      setViewport={setViewport}
      pins={pins}
      onViewStateChange={onViewStateChange}
      isInitiallyLoadedHook={[isMapInitiallyLoaded, setIsMapInitiallyLoaded]}
      isRoomsEmpty={false}
      {...rest}
    />
  );
};
